import classNames from 'classnames';
import { PropsWithChildren } from 'react';

interface IRows {
  borderTop?: boolean;
  borderBottom?: boolean;
  className?: string;
}

const Rows = ({
  children,
  borderTop,
  borderBottom = true,
  className = '',
}: PropsWithChildren<IRows>) => {
  const containerClasses = classNames(
    'tw-divide-y tw-divide-grey-20',
    className,
    {
      'tw-border-t tw-border-grey-20': borderTop,
      'tw-border-b tw-border-grey-20': borderBottom,
    }
  );

  return <div className={containerClasses}>{children}</div>;
};

export default Rows;
